let downloadPdf = {
    init() {
        $(document).on('click', 'span.check-item', function () {
            $(this).toggleClass('actif');
            let type_str = $(this).attr('data-type');
            let type = type_str.split('_');
            if (2 in type) {
                isActions(type[1] + '-' + type[2]);
            } else {
                isActions(type[1]);
            }
        });

        function isActions(table) {

            if ($('.table-' + table + ' span.check-item.actif').length > 0) {
                $(".header-view .actions[data-type='" + table + "']").addClass('actif');
            } else {
                $(".header-view .actions[data-type='" + table + "']").removeClass('actif');
            }
        }

        $(document).on('click', '.header-view .download', function () {
            if ($(this).parent().parent().hasClass('actif')) {

                let docs = [];

                let type = $(this).parent().parent().attr('data-type');
                $($('.table-' + type + ' span.check-item.actif')).each(function () {
                    docs.push($(this).attr('data-path'));
                });

                let type_name = type == 'cash-in' ? 'cash_in' : type;
                let data = {};
                data.docs = docs;
                data.type = "ekko_" + type_name;

                $.ajax({
                    type: 'POST',
                    url: '/zip-pdf-pro',
                    data: data,
                    success: function (response) {

                        //Lauch download zip
                        let url = response.split('/web/');
                        $('body').append('<a class="visuallyhidden download-zip" download href="/' + url[1] + '" target="_blank">&nbsp;</a>');
                        $('a.download-zip')[0].click();
                        $('a.download-zip').remove();

                        //Delete zip
                        let file = {};
                        file.url = response;
                        setTimeout(function () {
                            $.ajax({
                                type: 'POST',
                                url: '/delete-zip-pdf-pro',
                                data: file,
                                success: function (response) {
                                    resetCheckbox(type);
                                },
                                error: function (error) {
                                    alert(error.responseText + ' - ' + error.status);
                                }
                            })
                        }, 800);
                    },
                    error: function (error) {
                        alert(error.responseText + ' - ' + error.status);
                    }
                });


            }
        });


        $(document).on('click', '.header-view .email', function () {
            if ($(this).parent().parent().hasClass('actif')) {

                let docs = [];

                let type = $(this).parent().parent().attr('data-type');
                $($('.table-' + type + ' span.check-item.actif')).each(function () {
                    docs.push($(this).attr('data-path'));
                });

                let type_name = type == 'cash-in' ? 'cash_in' : type;
                let final_type = "ekko_" + type_name;
                let date = Date.now();

                let body = 'Bonjour,%0D%0A' +
                    'Veuillez trouver les documents téléchargés depuis le site du Laboratoire Arrow (format zip) en cliquant ou copiant le lien suivant dans un navigateur : %0D%0A' +
                    '' + window.location.origin + '/download-zip-pdf-pro?type=' + final_type + '%26stamp=' + date + '-' + drupalSettings.user.uid + '%26docs=' + docs +
                    '%0D%0AVous en souhaitant bonne réception.';
                window.location.href = "mailto:?subject=Laboratoire Arrow – Documents&body=" + body + "";

                resetCheckbox(type);
            }
        });

        /**
         * Uncheck all checkbox
         * @param type
         */
        function resetCheckbox(type) {
            $('.table-' + type + ' span.check-item').removeClass('actif');
        }

    }
}

export default downloadPdf;
